import { FC } from 'react';
import { ArrowRightIcon } from '@phosphor-icons/react';
import LureoButton from '@/common/LureoButton';
import lureoBetaLogo from '@/assets/Lureo_Beta.png';
import { ThemedLogo } from '@/modules/theme';
import { DesktopHandoff } from './DesktopHandoff';
import { desktopOnlyCopy } from './desktopOnlyCopy';

export const SignupDesktopHandoff: FC<{ onContinue: () => void }> = ({ onContinue }) => (
  <DesktopHandoff
    mark={<ThemedLogo src={lureoBetaLogo} alt="Lureo" className="h-auto w-40" />}
    title="Thanks for signing up"
    lead={`${desktopOnlyCopy.heading}.`}
    action={
      <LureoButton variant="secondary" className="h-12 rounded-lureo-radius-button-pill px-6" onClick={onContinue}>
        Look around
        <ArrowRightIcon className="h-5 w-5" />
      </LureoButton>
    }
  />
);
